import Swiper from "swiper";
import { Pagination } from "swiper/modules";


import Breakpoint from "@utils/breakpoint";
import { $ } from "@utils/dom";
import Viewport from "@utils/viewport";

const SWIPER_OPTIONS = {
  modules: [Pagination],
  pagination: {
    clickable: true,
  },
};

class PbRowFeaturedContent {
  constructor(el) {
    this.el = el;
    this.slider = $(".pb-row-featured-content__carousel", this.el);

    this._swiperOptions = { ...SWIPER_OPTIONS };
    this._swiperOptions.pagination.el = `#${this.el.id} .pb-row-featured-content__pagination`;

    this._onResize = this._onResize.bind(this);
    this._createSlider = this._createSlider.bind(this);
    this._destroySlider = this._destroySlider.bind(this);

    this.init();
  }

  init() {
    this._bp = Breakpoint(['(min-width: 768px)'], this._onResize);
    this._bindEvents();
  }
  destroy() {
    this._destroySlider();
    this._unbindEvents();

    if( this._bp ) this._bp.dispose();

    this.el = null;
    this.slider = null;
    this.swiper = null;

    this._bp = null;

    this._onResize = null;
    this._createSlider = null;
    this._destroySlider = null;
  }

  _bindEvents() {
    this._bp.on();
    this._bp.run();
  }
  _unbindEvents() {
    this._bp.off();
  }

  _onResize() {
    if( Viewport.width < 768 ) this._createSlider();
    else this._destroySlider();
  }
  _createSlider() {
    if( this.swiper || !this.slider ) return;

    this.swiper = new Swiper(this.slider, this._swiperOptions);
  }
  _destroySlider() {
    if( !this.swiper ) return;

    this.swiper.destroy();
    this.swiper = null;
  }
}

export default PbRowFeaturedContent;
